/**
 * User flows and custom policies for B2C application
 */

function getTenantName() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return 'logintest';
        // case 'example':
        //     return 'apiexample';
        default:
            return 'login';
    }
}

function getScopeSubdomain() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return 'apitest';
        // case 'example':
        //     return 'apiexample';
        default:
            return 'efundapi';
    }
}

function getClientId() {
    switch (process.env.VUE_APP_API_ENV) {
        case 'testapi':
        case 'dev':
        case 'local':
        case 'localtunnel':
            return '73ecdab7-b592-4a27-8b17-47f71b07275a';
        // case 'example':
        //     return 'apiexample';
        default:
            return '9faa7705-7be2-4757-af64-ba244bd4ecc4';
    }
}

const tenantName = getTenantName();
const scopeSubdomain = getScopeSubdomain();
const clientId = getClientId();
const loginPolicyId = 'B2C_1A_EFUND_SIGNIN';
//const loginPolicyId = 'B2C_1A_SIGNUP_SIGNIN';

export const b2cPolicies = {
    clientId: clientId,
    // authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${loginPolicyId}`,
    authority: `https://${tenantName}.efundraisingconnections.com/tfp/${tenantName}.efundraisingconnections.com/${loginPolicyId}`,
    // authorityDomain: `${tenantName}.b2clogin.com`,
    authorityDomain: `${tenantName}.efundraisingconnections.com`,
    scopes: ["openid", `https://${scopeSubdomain}.efundraisingconnections.com/api/user`],
}